var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M2.182 28h5.09V15.64L0 10.186V25.82A2.18 2.18 0 0 0 2.182 28"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M24.727 28h5.091A2.18 2.18 0 0 0 32 25.819V10.186l-7.273 5.454"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M24.727 6.187v9.453L32 10.186V7.278c0-2.697-3.08-4.235-5.237-2.617"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M7.273 15.64V6.187L16 12.731l8.728-6.544v9.452L16 22.184"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C5221F",
  d: "M0 7.278v2.908l7.273 5.454V6.187L5.236 4.661C3.076 3.043 0 4.58 0 7.278"
})));
export default SvgGmail;